// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"0cfba516","837":"3a7786c2","953":"8866098d"}[chunkId] + ".chunk.js";
};